//
import SlSaleCreditNoteModel from '@/models/Sale/SlSaleCreditNote'

/**
 * This class describes a sl customer.
 * @class SlSaleCreditNote (name)
 */
export default class SlSaleCreditNote extends SlSaleCreditNoteModel {

	/**
	 * Returns a list representation of the object.
	 * @return {Object} List representation of the object.
	 */
	static toCustomerDetail() {
		return class extends SlSaleCreditNoteModel {
			static includes = [
				'sl_customer',
				'sl_customer_branch_offices',
				'sl_detail_sale_credit_notes.wh_product',
				'sl_service_order.sl_sale_invoice_affected',
				'sl_service_order.sl_sale_ticket_affected',
			]
		}
	}

	/**
	 * Returns a list representation of the object.
	 * @return {Object} List representation of the object.
	 */
	static toList() {
		return class extends SlSaleCreditNoteModel {
			static includes = [
				'sl_customer',
				'sl_customer_branch_offices',
				'sl_detail_sale_credit_notes.wh_product',
				// 'sl_service_order.sl_sale_invoice_affected',
				// 'sl_service_order.sl_sale_ticket_affected',
			]
		}
	}
}